import dayjs from "dayjs";
import React, { useContext, useState, useEffect } from "react";
import GlobalContext from "../context/GlobalContext";
import { getDia } from "../util";

export default function Day({ day, rowIdx }) {
  const [dayEvents, setDayEvents] = useState([]);
  const {
    setDaySelected,
    setShowEventModal,
    filteredEvents,
    setSelectedEvent,
  } = useContext(GlobalContext);

  const { tipoFiltro } = useContext(GlobalContext);

  useEffect(() => {
    const events = filteredEvents.filter(
      (evt) =>
        dayjs(evt.day).format("DD-MM-YY") === day.format("DD-MM-YY")
    );
    setDayEvents(events);
  }, [filteredEvents, day]);

  useEffect(() => {
    //console.clear()
    //console.log(filteredEvents)
  }, [dayEvents]);

  function getCurrentDayClass() {
    return day.format("DD-MM-YY") === dayjs().format("DD-MM-YY")
      ? `bg-blue-600 text-white rounded-full ${tipoFiltro === 0 ? 'w-7' : 'w-12'}`
      : "";
  }
  return (
    <div className="border border-gray-200 flex flex-col" style={{maxHeight:"200px", height:"200px"}}>
      <header className="flex flex-col items-center">
        {rowIdx === 0 && (
          <p className="text-sm mt-1">
            {getDia(day.format("ddd").toUpperCase())}
          </p>
        )}
        <div
          className="w-100"
          style={{
            float: "left",
            display: "flex",
            alignItems: "center",
          }}
        >
          <p
            className={`text-sm p-1 my-1 text-center  ${getCurrentDayClass()}`}
            style={{ float: "left" }}
          >
            {tipoFiltro === 0 ? day.format("DD") : day.format("DD/MM")}
          </p>
          <i
            className="fa fa-plus-circle"
            style={{
              fontSize: "18px",
              float: "left",
              cursor: "pointer",
              marginLeft: "5px",
              marginTop: "-1px",
              color: "#837878",
            }}
            onClick={() => {
              setDaySelected(day);
              setShowEventModal(true);
            }}
          ></i>
        </div>
      </header>
      <div
        className="flex-1 cursor-pointer minha-div"
        onClick={() => {
          setDaySelected(day);
          setShowEventModal(true);
        }}
      >
        {dayEvents.map((evt, idx) => (
          <div
            key={idx}
            onClick={() => setSelectedEvent(evt)}
            className={`bg-${evt.label}-200 p-1 text-gray-600 text-sm rounded mb-1 truncate`}
            style={{ fontSize: "10px" }}
          >
            {evt.sigla !== undefined && evt.sigla !== null
              ? `${evt.sigla} - `
              : ""}
            {evt.tipoCompromisso.desc}
            {!evt.tipoCompromisso.diaInteiro && (
              <span>
                &nbsp;-&nbsp;
                {evt.horaInicio} às {evt.horaFim}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
